import React, { memo } from 'react'
import { DOTNumberForm } from 'src/components/dot-number/DOTNumberForm'
import { SecureWrapper } from '../layout/SecureWrapper'

const DOTNumberComponent = () => {
  return (
    <SecureWrapper>
      <DOTNumberForm />
    </SecureWrapper>
  )
}

export const DOTNumber = memo(DOTNumberComponent)
